export default "__VITE_ASSET__DG8NzWfx__"